<template>
  <div>
    <el-dialog title="任务详情" :visible.sync="formVisible" :close-on-click-modal="false" top="3vh" width="800px" class="meeting-box">
      <div class="content" :style="'height: ' + windowHeight + 'px; overflow-y: auto;'">
        <div class="reimbursement">
          <el-timeline>
            <el-timeline-item v-for="(activity, index) in list" :key="activity.id || index" :timestamp="activity.createdTime">
              <div>{{ activity.title }}</div>
              <div>{{ getStateText(activity.state) }}</div>
              <div v-if="activity.errorLog" style="color: #f56c6c;">{{ activity.errorLog }}</div>
            </el-timeline-item>
          </el-timeline>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import sysTaskDetailsApi from '@/api/sys/sysTaskDetails'


export default {
  data() {
    return {
      list: [],
      formVisible: false
    }
  },
  created() {
    const windowHeight =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight;
    this.windowHeight = windowHeight - 150;
  },
  watch: {

  },
  methods: {
    handleShow(row) {
      sysTaskDetailsApi.fetchById(row.id).then(res => {
        this.list = res.data;
        if(res.data.length > 0){
          this.formVisible = true;
        }else{
          this.$message.error('没有明细')
        }
      })
    },
    getStateText(state) {
      const stateMap = {
        0: '执行中',
        1: '执行成功',
        2: '执行失败'
      };
      return stateMap[state] || '';
    }
  }
}
</script>
<style lang="scss" scoped>
.mt {
  margin-top: 10px;
}
.dialog-footer {
  position: absolute;
  bottom: 5px;
  text-align: right;
  right: 20px;
}

::v-deep.el-tabs {
  height: 100%;
  .el-tabs__content {
    height: 100%;
    overflow-y: auto;
    padding-bottom: 15px;
  }
}

::v-deep .meeting-box .el-dialog__body {
  padding: 10px 0;
}
.reimbursement {
  padding: 10px 20px;
}

/* 修改滚动条整体样式 */
::-webkit-scrollbar {
  width: 6px;
  /* 滚动条宽度 */
  background-color: #f1f1f1;
  /* 滚动条背景色 */
}

/* 修改滚动条滑块样式 */
::-webkit-scrollbar-thumb {
  background-color: #d2d2d2;
  /* 滑块颜色 */
  border-radius: 4px;
  /* 滑块圆角 */
}

/* 修改滚动条轨道样式 */
::-webkit-scrollbar-track {
  background-color: #f1f1f1;
  /* 轨道背景色 */
}

/* 修改滚动条角落样式 */
::-webkit-scrollbar-corner {
  background-color: #f1f1f1;
  /* 角落背景色 */
}

</style>
